import { useMutation } from '@tanstack/react-query';
import { useGrowthQuery } from '@/data/useGrowthQuery';
import { growthKeys } from '@/data/queryKeys';
import { useNotify } from '@/data/notifications';
import { exportAutopilotLogCsv, fetchAutopilotLog, type AutopilotLogFilters } from '../api';

const DEFAULT_AUTOPILOT_FILTERS: AutopilotLogFilters = { page: 1, limit: 100, days: 7 };

export function useAutopilotLog(filters: AutopilotLogFilters = DEFAULT_AUTOPILOT_FILTERS) {
  const queryFilters = filters as Record<string, unknown>;
  return useGrowthQuery({
    queryKey: [
      ...growthKeys.autopilotLog.list(queryFilters),
      ...growthKeys.autopilotLog.timeline(filters.days ?? 7),
    ],
    queryFn: () => fetchAutopilotLog(filters),
  });
}

export function useAutopilotLogMutations() {
  const notify = useNotify();

  const exportCsv = useMutation({
    mutationFn: exportAutopilotLogCsv,
    onSuccess: () => notify.success('Autopilot log export started'),
    onError: (e) => notify.error(e),
  });

  return { exportCsv };
}
